import { render, staticRenderFns } from "./Relay.vue?vue&type=template&id=3f4e0542&scoped=true"
import script from "./Relay.vue?vue&type=script&lang=js"
export * from "./Relay.vue?vue&type=script&lang=js"
import style0 from "./Relay.vue?vue&type=style&index=0&id=3f4e0542&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f4e0542",
  null
  
)

export default component.exports